import { render, staticRenderFns } from "./LensCreation.vue?vue&type=template&id=06db34eb"
import script from "./LensCreation.vue?vue&type=script&lang=js"
export * from "./LensCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports